// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-name-input.auto-width {
  max-width: 100%;
  width: fit-content;
}
.fi-name-input.auto-width .mat-mdc-form-field {
  width: fit-content;
  max-width: 100%;
}
.fi-name-input.auto-width .mat-mdc-form-field .mat-mdc-form-field-infix {
  width: fit-content;
}
.fi-name-input.auto-width .mat-mdc-form-field .mat-mdc-form-field-infix textarea {
  max-width: 100%;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-name-input/fi-name-input.component.scss"],"names":[],"mappings":"AACI;EACI,eAAA;EACA,kBAAA;AAAR;AACQ;EACI,kBAAA;EACA,eAAA;AACZ;AAAY;EACI,kBAAA;AAEhB;AADgB;EACI,eAAA;AAGpB","sourcesContent":[".fi-name-input {\r\n    &.auto-width {\r\n        max-width: 100%;\r\n        width: fit-content;\r\n        .mat-mdc-form-field {\r\n            width: fit-content;\r\n            max-width: 100%;\r\n            .mat-mdc-form-field-infix {\r\n                width: fit-content;\r\n                textarea {\r\n                    max-width: 100%;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
